import React, { useState } from 'react';
import { IconButton, InputAdornment, TextField, TextFieldProps } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useTranslation } from 'react-i18next';

const PasswordField = React.forwardRef<HTMLInputElement, TextFieldProps>(function PasswordField(
  props,
  ref
) {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const { InputProps, type, ...rest } = props;

  return (
    <TextField
      {...rest}
      inputRef={ref}
      type={visible ? 'text' : 'password'}
      InputProps={{
        ...InputProps,
        endAdornment: (
          <InputAdornment position="end">
            {InputProps?.endAdornment}
            <IconButton
              aria-label={visible ? t('auth.hide_password') : t('auth.show_password')}
              onClick={() => setVisible((current) => !current)}
              edge="end"
              size="small"
            >
              {visible ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
});

export default PasswordField;
